import React from 'react';
import ConnectionsMobileSubnav from './ConnectionsMobileSubnav';
import ErrorHandler from '../../../_molecules/ErrorHandler';
import TrackPageView from '@tracking/TrackPageView';
import ProgressiveProfilingForm from '../../../modals/ProgressiveProfilingModal/ProgressiveProfilingForm';
import StepOne from '../../../modals/ProgressiveProfilingModal/StepOne';
import StepTwo from '../../../modals/ProgressiveProfilingModal/StepTwo';
import MatchCriteriaTitleBase from './CreateMatchesForm/MatchCriteriaTitle';
import SectionHeader from '../../../_molecules/SectionHeader';
import SectionBreadcrumbs from '../../../_molecules/SectionBreadcrumbs';
import SectionBreadcrumb from '../../../_molecules/SectionBreadcrumb';
import { BodyLarge, DivWithShadowAlternate, H3, SectionWrapperInner, SectionWrapperOuter } from '@styled';

import useDocumentTitle from '@hooks/useDocumentTitle';

const MatchCriteriaTitle = props => <MatchCriteriaTitleBase submitButtonClass="createcriteria" {...props} />;

export const CreateMatchCriteriaPage = () => {
    useDocumentTitle('Create Match Criteria');
    return (
        <ErrorHandler>
            <TrackPageView>
                <ConnectionsMobileSubnav />

                <SectionWrapperOuter>
                    <SectionWrapperInner className="fade-in-fast">
                        <SectionHeader title="My ICSC Connections" />

                        <div className="mt-2 mb-1.5rem">
                            <SectionBreadcrumbs>
                                <SectionBreadcrumb route="/my-icsc/connections">Connections</SectionBreadcrumb>
                                <SectionBreadcrumb route="/my-icsc/connections/matches">My Matches</SectionBreadcrumb>
                                <SectionBreadcrumb isActive>Create New Match Criteria</SectionBreadcrumb>
                            </SectionBreadcrumbs>
                        </div>

                        <H3 className="mb-1.5rem">Create New Match Criteria</H3>

                        <BodyLarge>
                            Answer a few questions about what you’re looking for in order to unlock personalized
                            connection recommendations.
                        </BodyLarge>

                        <DivWithShadowAlternate className="mt-4 p-4">
                            <ProgressiveProfilingForm steps={[StepOne, StepTwo, MatchCriteriaTitle]} addNew />
                        </DivWithShadowAlternate>
                    </SectionWrapperInner>
                </SectionWrapperOuter>
            </TrackPageView>
        </ErrorHandler>
    );
};
